'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _IssuePage = require('./IssuePage.css');

var _IssuePage2 = _interopRequireDefault(_IssuePage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IssueGenderEquality = (_dec = (0, _reactCssModules2.default)(_IssuePage2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(IssueGenderEquality, _Component);

  function IssueGenderEquality(props) {
    (0, _classCallCheck3.default)(this, IssueGenderEquality);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IssueGenderEquality.__proto__ || (0, _getPrototypeOf2.default)(IssueGenderEquality)).call(this, props));

    _this.state = {
      title: 'The issue: Gender equality',
      description: 'Collecting data and scoring companies on gender equality is the first step towards sustainable change.',
      url: _config2.default.domain + _config2.default.routes.issueGenderEquality
    };
    return _this;
  }

  (0, _createClass3.default)(IssueGenderEquality, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'page issue-gef' },
        _container2.default.helmet(this.state.title, this.state.description, this.state.url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'section',
            { styleName: 'section' },
            _react2.default.createElement(
              'h1',
              { styleName: 'issue-top-label' },
              'The issue: ',
              _react2.default.createElement(
                'span',
                null,
                'Gender equality'
              )
            ),
            _react2.default.createElement(
              'h2',
              { styleName: 'issue-top-headline' },
              'Companies with gender equality are positioned for success'
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'issue-top-copy' },
              'Collecting data and scoring companies on gender equality is the first step towards sustainable change.'
            )
          ),
          _react2.default.createElement(
            'section',
            { styleName: 'section' },
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 4 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'issue-second-headline' },
                  _react2.default.createElement(
                    'span',
                    { style: { whiteSpace: 'nowrap' } },
                    '\u2014\u2014\u2014\u2014'
                  ),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    'h2',
                    null,
                    'Retirement plans are investing companies that score poorly on gender equality'
                  )
                )
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 8 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'issue-second-copy' },
                  _react2.default.createElement(
                    'p',
                    null,
                    'Female leadership is crucial, given there are only 6% female CEOs in the S&P 500. But gender diversity is not only necessary at the top; it\u2019s equally important across all levels of a company, from the boardroom to executive, management and workforce levels.'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'Asset managers like Vanguard are investing in companies that score poorly on gender equality \u2013 and they\u2019re using workers\u2019 retirement plan savings to do so. Through Vanguard, the retirement plans of companies like Amazon and Comcast are investing millions in publicly-traded companies with poor gender balance and poor adoption of policies promoting gender equality.'
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'section',
            { styleName: 'section' },
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 6 },
                _react2.default.createElement('div', { styleName: 'img-issue' })
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 6 },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'h2',
                    { styleName: 'issue-focus-label' },
                    'FOCUS: SUSTAINABILITY RISK'
                  ),
                  _react2.default.createElement(
                    'h3',
                    { styleName: 'issue-focus-headline' },
                    'Companies that score poorly on gender equality'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'issue-focus-copy' },
                    _react2.default.createElement(
                      'p',
                      null,
                      'Our gender equality fund ratings are powered by the ',
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: 'https://equileap.com/equileap-reports/',
                          title: 'Equileap reports',
                          xstrong: true
                        },
                        'Equileap Gender Equality Scorecard'
                      ),
                      ', inspired by the UN\u2019s Women Empowerment Principles. The Equileap Gender Equality Scorecard scores companies based on 19 criteria, including gender balance across the workforce, the gender pay gap, paid parental leave, and anti-sexual harassment policies.'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.companies + '#genderequality',
                          title: 'Companies: Gender equality',
                          xstrong: true
                        },
                        'Learn more',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'section-solutions-faq-background' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'section',
              { styleName: 'section section-solutions-faq' },
              _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 6 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'section-solutions-faq-cell' },
                    _react2.default.createElement(
                      'h2',
                      { styleName: 'issue-solutions-label' },
                      'The Solutions'
                    ),
                    _react2.default.createElement(
                      'h3',
                      { styleName: 'issue-solutions-headline' },
                      'Offer gender lens retirement plan options'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-solutions-copy' },
                      _react2.default.createElement(
                        'p',
                        null,
                        'Company retirement plans should offer fund options that are sustainably invested and invest with a gender lens.'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-link' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.solutionOfferSustainability,
                          title: 'Solution: Offer sustainability',
                          xstrong: true
                        },
                        'Explore solutions',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 6 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'section-solutions-faq-cell' },
                    _react2.default.createElement(
                      'h2',
                      { styleName: 'issue-faqs-label' },
                      'FAQs'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-headline' },
                      'Answers to common questions about how retirement plans and asset managers are financing gender inequality.'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-item' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.faqs + '#do-i-have-to-sacrifice-returns-in-order-to-invest-sustainably-',
                          title: 'Do I have to sacrifice returns in order to invest sustainably?',
                          xstrong: true
                        },
                        'Do I have to sacrifice returns in order to invest sustainably?'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-item' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.faqs + '#why-should-retirement-plans-add-a-sustainable-investment-option-',
                          title: 'Why should retirement plans add a sustainable investment option?',
                          xstrong: true
                        },
                        'Why should retirement plans add a sustainable investment option?'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-link' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.faqs,
                          title: 'FAQs',
                          xstrong: true
                        },
                        'View all',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null)
          )
        )
      );
    }
  }]);
  return IssueGenderEquality;
}(_react.Component)) || _class);
exports.default = IssueGenderEquality;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/IssuePage/IssueGenderEquality.js
// module id = 1485
// module chunks = 0